(()=>{"use strict";
const $=(s,r=document)=>r.querySelector(s);
const money=c=>"LE "+Math.round((Number(c)||0)/100).toLocaleString("en-US");
const esc=s=>String(s||"").replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
const le=n=>"LE "+Math.round(n).toLocaleString("en-US");
const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";

/* 1. SEARCH: products-only, with category shortcuts */
const initSearch=()=>{
 const form=$(".site-header .searchbar"),input=form&&form.querySelector('input[name="q"]');
 if(!form||!input)return;
 const addHidden=(n,v)=>{if(form.querySelector('input[name="'+n+'"]'))return;const t=document.createElement("input");t.type="hidden";t.name=n;t.value=v;form.appendChild(t)};
 addHidden("type","product");
 addHidden("options[unavailable_products]","last");
 form.addEventListener("submit",e=>{if(!input.value.trim())e.preventDefault()});
 const box=document.createElement("div");
 box.className="rv-ps";box.id="RvPredictive";box.setAttribute("role","listbox");box.hidden=true;
 // Appended to <body> and positioned fixed: the search form has overflow:hidden
 // for its pill shape, which would clip the dropdown to zero height.
 document.body.appendChild(box);
 box.style.position="fixed";
 box.style.zIndex="1350";
 const st=document.createElement("style");
 st.textContent=".rv-ps-head{margin:0;padding:10px 12px 0;font-size:10px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#a19c92}.rv-ps-cats{display:flex;flex-wrap:wrap;gap:6px;padding:8px 12px 6px}.rv-ps-cat{display:inline-flex;align-items:center;padding:6px 11px;border-radius:999px;background:#f2efe7;color:#141512;font-size:12px;font-weight:700;text-decoration:none}.rv-ps-cat:hover,.rv-ps-cat:focus{background:#141512;color:#fff}";
 document.head.appendChild(st);
 const positionBox=()=>{
  const r=input.getBoundingClientRect();
  if(!r.width){
   // Search field is not laid out (hidden in a collapsed mobile header): pin the list under the top bar.
   box.style.left="10px";box.style.top="64px";box.style.width="calc(100vw - 20px)";
   return;
  }
  box.style.left=r.left+"px";
  box.style.top=r.bottom+"px";
  box.style.width=r.width+"px";
 };
 positionBox();
 window.addEventListener("resize",positionBox,{passive:true});
 window.addEventListener("scroll",positionBox,{passive:true,capture:true});
 input.setAttribute("aria-controls","RvPredictive");input.setAttribute("aria-autocomplete","list");
 let timer=0,ctrl=null,last="";
 const close=()=>{box.hidden=true;input.setAttribute("aria-expanded","false")};
 const render=(q,products,cols)=>{
  const cats=cols.filter(c=>c&&c.url&&c.title).slice(0,4);
  const allUrl=root+"search?q="+encodeURIComponent(q)+"&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last";
  if(!products.length&&!cats.length){
   box.innerHTML='<p class="rv-ps-empty">No products match "'+esc(q)+'"</p><a class="rv-ps-all" href="'+root+'collections">Browse all categories →</a>';
  }else{
   const catHtml=cats.length?'<p class="rv-ps-head">Categories</p><div class="rv-ps-cats">'+cats.map(c=>'<a class="rv-ps-cat" role="option" href="'+esc(c.url)+'">'+esc(c.title)+'</a>').join("")+'</div>':'';
   const prodHtml=products.map(p=>{
    const src=(p.featured_image&&p.featured_image.url)||p.image||"";const img=src?src+(src.indexOf("?")>-1?"&":"?")+"width=120":"";
    const pr=Number(p.price)||0,cp=Number(p.compare_at_price_max)||0;const was=cp>pr?'<s>'+le(cp)+'</s>':'';
    const sold=p.available===false?' · Sold out':'';
    return '<a class="rv-ps-item" role="option" href="'+esc(p.url)+'">'+
      '<span class="rv-ps-img">'+(img?'<img src="'+esc(img)+'" alt="" loading="lazy" width="48" height="48">':'')+'</span>'+
      '<span class="rv-ps-txt"><b>'+esc(p.title)+'</b><small>'+esc((p.type||"")+sold)+'</small></span>'+
      '<span class="rv-ps-price">'+le(pr)+was+'</span></a>';
   }).join("");
   box.innerHTML=catHtml+(products.length?'<p class="rv-ps-head">Products</p>'+prodHtml:'')+'<a class="rv-ps-all" href="'+allUrl+'">See all results for "'+esc(q)+'" →</a>';
  }
  positionBox();
  box.hidden=false;input.setAttribute("aria-expanded","true");
 };
 const run=async q=>{
  if(ctrl)ctrl.abort();ctrl=new AbortController();
  try{
   const r=await fetch(root+"search/suggest.json?q="+encodeURIComponent(q)+"&resources[type]=product,collection&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last",{signal:ctrl.signal});
   if(!r.ok)return;
   const d=await r.json();
   if(q!==input.value.trim())return;
   const res=(d.resources&&d.resources.results)||{};
   render(q,res.products||[],res.collections||[]);
  }catch(_){}
 };
 input.addEventListener("input",()=>{
  const q=input.value.trim();clearTimeout(timer);
  if(q.length<1){close();return}
  if(q===last&&!box.hidden)return;last=q;
  timer=setTimeout(()=>run(q),120);
 });
 input.addEventListener("focus",()=>{if(input.value.trim().length>=1&&box.innerHTML){positionBox();box.hidden=false}});
 input.addEventListener("keydown",e=>{
  const items=[...box.querySelectorAll("a")];
  if(e.key==="Escape"){close();return}
  if(e.key==="ArrowDown"&&items.length){e.preventDefault();items[0].focus()}
 });
 box.addEventListener("keydown",e=>{
  const items=[...box.querySelectorAll("a")],i=items.indexOf(document.activeElement);
  if(e.key==="ArrowDown"){e.preventDefault();(items[i+1]||items[0]).focus()}
  else if(e.key==="ArrowUp"){e.preventDefault();i<=0?input.focus():items[i-1].focus()}
  else if(e.key==="Escape"){close();input.focus()}
 });
 document.addEventListener("click",e=>{if(!form.contains(e.target)&&!box.contains(e.target))close()});
 window.addEventListener("pageshow",e=>{if(e.persisted)close()});
};

/* 2. STICKY ADD-TO-CART */
const initSticky=()=>{
 const form=$("#RavenProductForm"),btn=form&&form.querySelector(".rp-add-btn"),bar=$("#RvSticky");
 if(!form||!btn||!bar)return;
 const sbtn=bar.querySelector("button"),sprice=bar.querySelector("[data-sticky-price]"),price=$("#RavenProductPrice .rp-price");
 const sync=()=>{
  const p=$("#RavenProductPrice .rp-price");
  if(p&&sprice)sprice.textContent=p.textContent;
  sbtn.disabled=btn.disabled;sbtn.textContent=btn.disabled?"Sold out":"Add to cart";
 };
 sbtn.addEventListener("click",()=>{if(!btn.disabled){if(form.requestSubmit)form.requestSubmit(btn);else btn.click()}});
 new MutationObserver(sync).observe(btn,{attributes:true,childList:true,subtree:true});
 if(price)new MutationObserver(sync).observe($("#RavenProductPrice"),{childList:true,subtree:true});
 sync();
 if("IntersectionObserver"in window){
  new IntersectionObserver(([en])=>{bar.classList.toggle("is-on",!en.isIntersecting&&en.boundingClientRect.top<0)},{threshold:0}).observe(btn);
 }
};

/* 3. RECENTLY VIEWED */
const KEY="rv_recent_v1";
const readRecent=()=>{try{return JSON.parse(localStorage.getItem(KEY)||"[]")}catch(_){return[]}};
const initRecent=()=>{
 const cur=$("[data-rv-product]");
 let list=readRecent();
 if(cur){
  const me={h:cur.dataset.handle,t:cur.dataset.title,u:cur.dataset.url,i:cur.dataset.image,p:+cur.dataset.price,c:+cur.dataset.compare||0,v:cur.dataset.vendor};
  list=[me,...list.filter(x=>x.h!==me.h)].slice(0,12);
  try{localStorage.setItem(KEY,JSON.stringify(list))}catch(_){}
 }
 const wrap=$("[data-rv-recent]");if(!wrap)return;
 const show=list.filter(x=>!cur||x.h!==cur.dataset.handle).slice(0,8);
 if(!show.length)return;
 wrap.querySelector(".rv-row-track").innerHTML=show.map(x=>
  '<article class="rv-p">'+(x.c>x.p?'<span class="rv-p-save">Save '+Math.round((x.c-x.p)/x.c*100)+'%</span>':'')+
  '<a class="rv-p-img" href="'+esc(x.u)+'" tabindex="-1" aria-hidden="true">'+(x.i?'<img src="'+esc(x.i)+'" alt="" loading="lazy">':'<span class="rv-p-ph">R</span>')+'</a>'+
  (x.v&&x.v!=="ravenpetstore"?'<p class="rv-p-vendor">'+esc(x.v)+'</p>':'')+'<h3 class="rv-p-title"><a href="'+esc(x.u)+'">'+esc(x.t)+'</a></h3>'+
  '<div class="rv-p-price"><span class="rv-p-now">'+money(x.p)+'</span>'+(x.c>x.p?'<s class="rv-p-was">'+money(x.c)+'</s>':'')+'</div>'+
  '<a class="rv-p-btn" href="'+esc(x.u)+'">View product</a></article>').join("");
 wrap.hidden=false;
};

/* 4. ORDER ON WHATSAPP (Egypt) */
const WA="201552411517";
const initWaOrder=()=>{
 const form=$("#RavenProductForm");if(!form||$(".rv-wa-order"))return;
 const cur=$("[data-rv-product]");
 const a=document.createElement("a");
 a.className="rv-wa-order";a.target="_blank";a.rel="noopener noreferrer";
 a.innerHTML='<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 3A13 13 0 0 0 4.7 22.5L3.4 27.3a.8.8 0 0 0 1 1l4.9-1.3A13 13 0 1 0 16 3Z"/></svg><span>Order on WhatsApp</span>';
 const build=()=>{
  const title=(cur&&cur.dataset.title)||document.title;
  const sel=$("#RavenProductVariant");
  const opt=sel&&sel.selectedOptions[0]?sel.selectedOptions[0].textContent.split(" — ")[0].trim():"";
  const qty=($("#RavenQty")||{}).value||"1";
  const price=(($("#RavenProductPrice .rp-price")||{}).textContent||"").trim();
  const url=location.origin+((cur&&cur.dataset.url)||location.pathname);
  const lines=["Hi Raven, I'd like to order:","","• "+title+(opt?" ("+opt+")":""),"• Quantity: "+qty];
  if(price)lines.push("• Price: "+price);
  lines.push("",url);
  a.href="https://wa.me/"+WA+"?text="+encodeURIComponent(lines.join("\n"));
 };
 ["change","input","click"].forEach(ev=>form.addEventListener(ev,()=>setTimeout(build,0)));
 a.addEventListener("click",build);
 build();
 const anchor=form.querySelector(".rp-buy-now")||form.querySelector(".rp-buy-row");
 if(anchor)anchor.insertAdjacentElement("afterend",a);
};

/* 5. PRODUCT ROW ARROWS (single shared init) */
const initRows=()=>{
 document.querySelectorAll(".rv-row-wrap").forEach(w=>{
  if(w.dataset.rvInit)return;w.dataset.rvInit="1";
  const t=w.querySelector("[data-rv-track]"),p=w.querySelector("[data-rv-prev]"),n=w.querySelector("[data-rv-next]");
  if(!t||!p||!n)return;
  const upd=()=>{const max=t.scrollWidth-t.clientWidth-2;p.hidden=t.scrollLeft<=2;n.hidden=t.scrollLeft>=max};
  const step=()=>Math.max(212,Math.round(t.clientWidth*.8));
  p.addEventListener("click",()=>t.scrollBy({left:-step(),behavior:"smooth"}));
  n.addEventListener("click",()=>t.scrollBy({left:step(),behavior:"smooth"}));
  t.addEventListener("scroll",upd,{passive:true});
  addEventListener("resize",upd,{passive:true});
  upd();
 });
};

const ready=()=>{initRows();initSearch();initSticky();initRecent();initWaOrder()};
document.readyState==="loading"?document.addEventListener("DOMContentLoaded",ready):ready();
})();
